import React from "react";
import './jigyasa-assessments.scss';
import NewAssessment from "./new-assessment/new-assessment";
import SchoolApi from "../../apis/school";
import ClickerFlowPractice from "../jigyasa-assessment/jigyasa-assessment";
import ToasterComponent from "../common/cw-toaster-component/cw-toaster-component";


class JigyasaAssessments extends React.Component {


    state = {
        schoolsList: []
    }



    onClickNewHomeWork() {
        this.getJigyasaSchoolsList()
        this.setState({ showNewAssessment: true })
    }

    getJigyasaSchoolsList() {

        let payload = {}

        SchoolApi.getJigyasaSchools(payload).then(res => {
            console.log(res)

            this.setState({ schoolsList: res.response })

        }).catch(err => {
            console.log(err)
        })
    }


    hideNewAssessment() {
        this.setState({ showNewAssessment: false })
        
    }

    showSuccessMessage() {
        this.hideNewAssessment()
        this.showToaster('info', "Assessment Created successfully")
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 8000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }


    render() {

        if (this.state.showNewAssessment && this.state.schoolsList?.length !== 0) {
            return <NewAssessment delegate={this} />
        }

        return (
            <div className="jigyasa-assessments">
                <ClickerFlowPractice delegate={this} />
                {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
            </div>
        )
    }
}


export default JigyasaAssessments;